import React, { memo, useCallback, useRef, useEffect, useState } from 'react';
import { TextInput, Unform, Button, MaskInput, Switch, CustomIcon } from 'components';
import { Box, Flex, Heading, Link } from '@chakra-ui/layout';
import { useDisclosure } from '@chakra-ui/hooks';
import { IClientsResponse } from 'types/clients';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal';
import { openNotification } from 'utils/notification';
import { createClient } from 'services/createClient';
import { clientsValidationSchema } from 'yupSchemas/clients';
import { FormHandles } from '@unform/core';

import styled from 'styled-components';
import { getAllClients } from 'services/client';

const SwitchBox = styled.div`
  span {
    background-color: #ccc;
    height: 1rem;
  }
  .css-lbwokm[data-checked] {
    background-color: #60dfdb;
  }

  .chakra-switch__thumb {
    background-color: #fff;
  }
`;
interface IProps {
  postCreateClient?(): void;
}

const AddClientModal: React.FC<IProps> = ({ postCreateClient }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = React.useState(false);
  const formRef = useRef<FormHandles>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [clients, setClients] = useState<{ name: string; id: React.ReactText }[]>([]);

  const handleSubmit = useCallback(async (formData: IClientsResponse) => {
    try {
      setIsLoading(true);

      await createClient(formData);

      onClose();

      postCreateClient?.();

      openNotification('Cliente criado com sucesso!', 'success');
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handleGetData = async () => {
    try {
      const { data } = await getAllClients('');
      setClients(data);
    } catch (error) {}
  };
  useEffect(() => {
    handleGetData();
  }, []);

  return (
    <Flex>
      <Link
        fontWeight="700"
        fontSize="14px"
        color="brand.tertiary"
        textDecoration="underline"
        textUnderlineOffset="4px"
        mb="2px"
        transition="opacity 120ms ease-in"
        _hover={{
          opacity: '.85',
        }}
        _active={{
          opacity: '.5',
        }}
        onClick={onOpen}
      >
        + Adicionar Cliente
      </Link>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent maxW="600px" p="24px" w="571px" minH="225px" borderRadius="8px">
          <Unform
            onSubmit={handleSubmit}
            formRef={formRef}
            validationSchema={clientsValidationSchema}
          >
            <ModalHeader
              display="flex"
              p="0"
              mb="1rem"
              alignItems="center"
              justifyContent="space-between"
            >
              <Heading fontSize="18px" fontWeight="bold" color="brand.gray600">
                Novo Cliente
              </Heading>
              <Box
                bg="brand.1300"
                borderRadius="50%"
                fontSize="14px"
                fontWeight="bold"
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                as="button"
                type="button"
                border="none"
                color="brand.red100"
                onClick={onClose}
              >
                <CustomIcon size="22px" $noSphere icon="round_close" />
              </Box>
            </ModalHeader>

            <ModalBody w="auto" maxW="full" p="0">
              <Flex flexDirection="column">
                <Flex flex={1}>
                  <Box w="200px">
                    <MaskInput
                      mask="numberInput"
                      name="id"
                      placeholder="Digite Aqui"
                      label="Pasta"
                    />
                  </Box>
                  <Box flex="1" paddingLeft="1rem">
                    <TextInput name="name" placeholder="Digite Aqui" label="Nome do Cliente" />
                  </Box>
                </Flex>

                <SwitchBox>
                  <Switch
                    name="enableHoursBank"
                    label="Controle de Horas"
                    className="switchChakra"
                  />
                </SwitchBox>
              </Flex>
            </ModalBody>

            <ModalFooter w="100%" padding={'1rem 0 0'}>
              <Flex w="100%" flex="1" justifyContent="space-between">
                <Box marginRight="1rem">
                  <Button outline variant="gray" type="button" onClick={onClose}>
                    Cancelar
                  </Button>
                </Box>
                <Box>
                  <Button
                    type="button"
                    onClick={() => formRef.current?.submitForm()}
                    isLoading={isLoading}
                  >
                    Salvar
                  </Button>
                </Box>
              </Flex>
            </ModalFooter>
          </Unform>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export const AddClient = memo(AddClientModal);
